import { useCallback, useLayoutEffect, useRef } from "react";

const useScrollPositionRestore = ({ shouldRestore, getScrollContainer }) => {
  const scrollPositionRef = useRef(null);

  const captureScrollPosition = useCallback(() => {
    const scrollContainer = getScrollContainer?.();
    scrollPositionRef.current = scrollContainer?.scrollTop ?? window.scrollY;
  }, [getScrollContainer]);

  useLayoutEffect(() => {
    if (!shouldRestore || scrollPositionRef.current === null) return;

    const scrollTop = scrollPositionRef.current;
    scrollPositionRef.current = null;

    const scrollContainer = getScrollContainer?.();
    (scrollContainer ?? window).scrollTo({ top: scrollTop, behavior: "auto" });
  }, [getScrollContainer, shouldRestore]);

  return { captureScrollPosition };
};

export default useScrollPositionRestore;
